import { useBoolean } from "@vega-core/hooks/useBoolean";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isTruthy } from "@vega-core/utils/isTruthy";

import { LinkTextButton } from "../../Buttons/LinkTextButton";
import { EmailContactModal } from "../../Modals/EmailContactModal/EmailContactModal";
import { Notice, NoticeType } from "../../Notice/Notice";

type Props = {
  message: string;
  contactLabel?: string;
  type?: NoticeType;
  withContact?: boolean;
};

export const ActionStatusMessage = ({
  message,
  type = NoticeType.INFO,
  withContact,
  contactLabel,
}: Props) => {
  const { contacts } = usePublicConfig();

  const isContactModalOpen = useBoolean(false);

  if (!isTruthy(message)) return null;

  return (
    <>
      <Notice
        className="mb-3"
        content={
          <div className="whitespace-normal">
            <span>{message}</span>

            {withContact ? (
              <>
                &nbsp;
                <LinkTextButton
                  className={cnTwMerge(
                    "min-h-1",
                    type === NoticeType.ERROR && "text-text/primary",
                  )}
                  onClick={isContactModalOpen.setTrue}
                  text={contactLabel ?? m.titles_contactUs()}
                />
              </>
            ) : null}
          </div>
        }
        type={type}
      />

      {isTruthy(withContact) && isTruthy(contacts.helpEmail) ? (
        <EmailContactModal
          email={contacts.helpEmail}
          onClose={isContactModalOpen.setFalse}
          open={isContactModalOpen.value}
        />
      ) : null}
    </>
  );
};
